import { HelpCircleIcon, Text } from '@thefarmersfront/kitchen';

import { useTooltipStore } from '~/store';

import styles from './DeliveryAgencyEstimatedDeliveryDateLabel.module.scss';

const ESTIMATED_DELIVERY_DATE_TOOLTIP =
  '당일배송 주문은 배송예정일이 주문 등록일 다음 날 (D+1)입니다. 당일배송이더라도 D+1으로 선택하여 검색 부탁드립니다.';

const DeliveryAgencyEstimatedDeliveryDateLabel = () => {
  const { tooltip, setTooltip } = useTooltipStore();

  const handleMouseEnter = () => {
    setTooltip({ show: true, description: ESTIMATED_DELIVERY_DATE_TOOLTIP });
  };

  const handleMouseLeave = () => {
    setTooltip({ ...tooltip, show: false });
  };

  return (
    <div className={styles.label}>
      <Text size="small" weight="semi-bold" element="p">
        배송 예정일
      </Text>
      <HelpCircleIcon
        className={styles.icon}
        size={16}
        color="gray400"
        data-tooltip-id="react-tooltip"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
    </div>
  );
};

export { DeliveryAgencyEstimatedDeliveryDateLabel };
